export const TABLE_GUTTER_SIZE = 12;
export const TITLE_COLUMN_WIDTH = 87;
export const OPERATOR_COLUMN_WIDTH = 168;
export const BUTTON_COLUMN_WIDTH = 27;
